import ApiService from "@/core/services/ApiService";

class AcrdService {

    public static getAcreditation(id: any, action: any) {
        ApiService.setHeader()
        return ApiService.get(`api/acreditation/${id}`, action)
        //api/acreditation/789654/show
    }

    public static changeStatus(slug: any, data: any){
        ApiService.setHeader()
        return ApiService.post(`api/${slug}/change-status`, data)
    }

    public static getCompetitionTest(data: any){
        ApiService.setHeader()
        return ApiService.post('api/acreditation/consolidate-test', data)
    }

    public static getAtletaTest(data: any){
        ApiService.setHeader()
        return ApiService.post('api/acreditation/atleta-test', data)
    }

    public static saveTestAtlete(data: any) {
        ApiService.setHeader()
        return ApiService.post('api/acreditation/test-save', data)
    }

    public static deleteTestAtlete(data: any) {
        ApiService.setHeader()
        return ApiService.post('api/acreditation/test-delete', data)
    }

    public static saveMedalla(data: any) {
        ApiService.setHeader()
        return ApiService.post('api/acreditation/medalla-save', data)
    }

    public static options(slug: string, params: any){
        ApiService.setHeader()
        return ApiService.post(`api/acreditation/${slug}`, params)
    }

    public static delete(id: string) {
        ApiService.setHeader()
        return ApiService.delete(`api/acreditation/${id}`, 'delete')
    }

}

export default AcrdService;